import { Swiper, Pagination, Autoplay, EffectFade } from 'swiper'

Swiper.use([Pagination, Autoplay, EffectFade])

const fn = {
  init: () => {
    document.querySelectorAll('.testimonials-slider').forEach((el) => fn.setupSlider(el))

    document.querySelectorAll('.testimonials-pagination-slider').forEach((el) => fn.setupPaginationSlider(el))
  },

  setupSlider: (el) => {
    const container = el.querySelector('.swiper-container')

    if (!container) {
      return
    }

    const numSlides = container.querySelectorAll('.swiper-slide').length

    const opts = {
      slidesPerView: 1,
      speed: 500,
      autoplay: {
        delay: 12000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    }

    if (numSlides > 1) {
      new Swiper(container, opts)
    }
  },

  setupPaginationSlider: (el) => {
    const container = el.querySelector('.swiper-container')

    if (!container) {
      return
    }

    const numSlides = container.querySelectorAll('.swiper-slide').length

    const opts = {
      slidesPerView: 1,
      speed: 500,
      loop: true,
      autoplay: {
        delay: 12000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: container.querySelector('.testimonials-button-next'),
        prevEl: container.querySelector('.testimonials-button-prev'),
      },
    }

    if (numSlides > 1) {
      new Swiper(container, opts)
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
